import React, { useRef, useContext, useState, useEffect } from "react";
import { getStyle } from "../../../styles/styles";
import AppContext from "../../../AppContext";
import NewEditableGrid from "../../shared/NewEditableGrid";
import AlertBox from "../../shared/AlertBox";
import { getListForPricing, vinculatePricing } from "../../../networking/NetworkingCustomers";
import { getPricingCategory } from "../../../networking/NetworkingPricing";

const style = getStyle();

const BNCustomerPricing = (loadCustomer) => {
    const context = useRef(useContext(AppContext));
    const [data, setData] = useState([])
    const [columnDetail, setColumnDetail] = useState(null);
    const [reloadCustomers, setReloadCustomers] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [pricingTypes, setPricingTypes] = useState([])

    useEffect(() => {
        async function loadGrid(){
            const json = await getListForPricing(0, 0);
            if (json != null && json.customers != null){
                setData(json.customers);
                if (json.columnDetail != null) {
                    const _columnDetail = JSON.parse(json.columnDetail);
                    setColumnDetail(_columnDetail);
                }
            }
        }
        loadGrid();
    }, [reloadCustomers, loadCustomer])

    useEffect(() => {
        async function loadPricingCategories(){
            const json = await getPricingCategory();
            if (json != null && json.pricingCategories != null) {
                let list = []
                json.pricingCategories.map(category => {
                    var elementList = {
                        value: category["Category ID"],
                        name:  category["Category Name"]
                    }
                    list.push(elementList);
                })
                setPricingTypes(list);
            }
        }
        loadPricingCategories();
    }, [loadCustomer])
    
    const save = async (record, row) => {
        try{
            debugger;
            let model = {
                customerId: record['Customer ID'],
                pricingId:  row['Category']
            }

            context.current.startLoading();
            //Call save method
            const vinculatePricingResponse = await vinculatePricing(model); 
            context.current.finishLoading();

            let title = 'Error';
            let message = 'Something went wrong when assining Pricing to Customer. Please try again later.';

            if (vinculatePricingResponse !== undefined) {
                if(vinculatePricingResponse.httpStatusCode === 200 && vinculatePricingResponse.Result){
                    title = 'Success';
                    message = 'Pricing successfuly linked to customer.';
                } else {
                    if(vinculatePricingResponse.Message !== undefined && vinculatePricingResponse.Message !== null && vinculatePricingResponse.Message !== ''){
                        message = vinculatePricingResponse.Message;
                    }
                }
                
                setAlertTitle(title);
                setAlertMessage(message);
                setShowAlert(true);
        
                if(title === 'Success') {
                    setReloadCustomers(!reloadCustomers);
                }
            } else {
              setAlertTitle('Error');
              setAlertMessage('Something went wrong. Please try again later.');
              setShowAlert(true);
            }
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
          }
    }

    const closeAlert = () => {
        setShowAlert(false);
        setAlertTitle('');
        setAlertMessage('');
    };
    
        return (
            <div>
                <h3 className="uk-heading-divider" style={style.titleStyle} >Customers</h3>
                <NewEditableGrid
                    data={data}
                    columnDetails={columnDetail}
                    dynamicOptions={{
                        'Category': pricingTypes
                    }}
                    isEditable={true}
                    editSaveFunction={save}
                    canAdd={false}
                    useIcons={true}
                />
                <AlertBox open={showAlert} onClose={closeAlert} title={alertTitle} message={alertMessage} type="Ok" okClick={closeAlert} />
            </div>
        )
}

export default BNCustomerPricing;